module.exports = __webpack_public_path__ + "img/chevron-bg.8c3d64b0.svg";